<template>
  <div class="iframe-video">
		<app-full-sticky-bg isPlay />
		<iframe
			:src="videoUrl"
			allowfullscreen>
		</iframe>
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	import brandingMixin from '@/mixins/branding'

	import FullStickyBg from '@/components/fullStickyBg/fullStickyBg'

	export default {
		mixins: [brandingMixin],
		components: {
			appFullStickyBg: FullStickyBg
		},
		computed: {
			...mapState('tours', ['video']),
			videoUrl () {
				const {
					isVimeo,
					vimeoUrlBranded,
					vimeoUrlUnbranded,
					iframeUrlBranded,
					iframeUrlUnbranded
				} = this.video;

				if (this.isBranded) {
					return isVimeo ? vimeoUrlBranded : iframeUrlBranded
				}

				return isVimeo ? vimeoUrlUnbranded : iframeUrlUnbranded
			}
		}
	}
</script>

<style lang="scss">
	.iframe-video {
		width: 100%;
		height: 100%;
		//padding-bottom: 56.25%;

		//@media (min-aspect-ratio: 16/9) {
			//height: 300%;
			//top: -100%;
		//}
		//@media (max-aspect-ratio: 16/9) {
		//	width: 300%;
		//	left: -100%;
		//}

		.full-sticky-bg {
			position: absolute;
			z-index: 5;
		}

		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border: none;
		}
	}
</style>
